export const BID_TRANSITION_DELAY = 3000

export enum AuctionState {
  Scheduled = 'SCHEDULED',
  Active = 'ACTIVE',
  Ending = 'ENDING',
  Ended = 'ENDED',
  Canceled = 'CANCELED',
}

export enum BuyNowState {
  Scheduled = 'SCHEDULED',
  Active = 'ACTIVE',
  Ended = 'ENDED',
}
